module.exports = __webpack_public_path__ + "img/Bear20.6c06a70e.jpg";